'use strict'

import * as components from './components'
import config, { setOptions } from './config/index'
import { merge } from '@akerolabs/akero-vue/src/utils/helpers'
import { setVueInstance } from '@akerolabs/akero-vue/src/utils/config'

import {
  use,
  registerComponentProgrammatic,
} from '@akerolabs/akero-vue/src/utils/plugins'

/**
 * @type {Object}
 * @property {Function} install - The method that binds all of the
 * components ect.
 * @description The core plugin that will be used to extend Vue.js with
 * all of the main components that wrapper up the CSS, this will make
 * building components faster as developers won't need to remember much
 * of the CSS to make nice looking UI components.
 */
const AkeroUIComponents = {
  /**
   * @param {Vue} Vue - The Vue instance to extend
   * @param {Object} options - The options to set for the akero components
   * @description Installs all of the akero ui components into the Vue
   * instance that was given.
   */
  install(Vue, options = {}) {
    setVueInstance(Vue)
    setOptions(merge(config, options, true))

    for (let componentKey in components) {
      const { name, ...rest } = components[componentKey]
      Vue.component(name, rest)
    }

    const AkeroUIProgrammatic = {
      getOptions() {
        return config
      },

      setOptions(options) {
        setOptions(merge(config, options, true))
      },
    }

    registerComponentProgrammatic(Vue, 'config', AkeroUIProgrammatic)
  },
}

use(AkeroUIComponents)

export default AkeroUIComponents
export * from './components'
